import { mappingTableURI, notEncodedURLParams } from '@/enums/constants';

/**
 * AF encoding URI single value
 * @param {string | number} valueToEncode Value to encode for the param
 *
 * @return {string} Param encode with AF mapping
 */
export function encodeAfURIValue(valueToEncode: string | number | boolean) {
  // Encode the value with Mozila method
  let encodedValue = encodeURIComponent(valueToEncode);
  for (const [searchedKey, replacedValue] of Object.entries(mappingTableURI)) {
    encodedValue = encodedValue.replaceAll(searchedKey, replacedValue);
  }
  return encodedValue;
}

/**
 * AF encoding URI params for Viktor
 *
 * @remark To think again on code organisation or logic
 *
 * @param {Record<string, unknown>} params Params to encode
 *
 * @return {string} Query params encoded with AF mapping
 */
export function encodeAfURIParams(params: Record<string, string | string[] | number | number[] | boolean>) {
  // Set params to be encoded and returned by the function to avoid mutability
  return Object.entries(params).reduce((acc, [keyParam, valueParam]) => {
    // Check if key of params is in the exluded list of encoding value
    if (valueParam !== undefined) {
      // Split key by bracket to get search keys
      const baseKey = keyParam.split('[')[0];
      if (baseKey && notEncodedURLParams.indexOf(baseKey) !== -1) {
        acc[keyParam] = Array.isArray(valueParam) ? valueParam.join() : valueParam;
      } else if (Array.isArray(valueParam)) {
        // If key value should be encoded, check if it is an array
        const encodedList = valueParam.map(value => {
          // Encode each value of array
          return encodeAfURIValue(value);
        });
        acc[keyParam] = encodedList.join();
      } else {
        // Encode value
        acc[keyParam] = encodeAfURIValue(valueParam);
      }
    }

    return acc;
  }, {});
}
